import React, { useEffect } from 'react';
import { useUserAlarm } from '../../../hooks/useUserAlarm';
import AlarmModal from './AlarmModal';

export default function MainAlarmPopup({ homeYn }) {
    const { alarmData, hasAlarm, showPopup, setShowPopup, loading } = useUserAlarm();

    useEffect(() => {
        if (homeYn && hasAlarm) {
            setShowPopup(true);
        }
    }, [homeYn, hasAlarm, setShowPopup]);

    if (loading || !showPopup) return null;

    return (
        <AlarmModal
            data={alarmData}
            onClose={() => setShowPopup(false)}
        />
    );
}